<div class="w-70 p-2 rounded-br-2xl bg-lugano-black/80 shadow-md">
  <ul>
    @for (filter of filters; track $index) {
    <li
      class="h-10 px-4 py-2 not-last:mb-2 flex justify-between items-center cursor-pointer rounded-xl text-sm font-medium bg-lugano-gray hover:bg-lugano-gray-light"
      [style.color]="filter.type === 'vip' ? vipColor : regularColor"
      (click)="onFilter(filter)">
      {{ filter.name }}
      @if (filter.mode === 'view360') {
        <i id="view360"></i>
      }
    </li>
    }
  </ul>
</div>